import { Inject, Injectable } from '@angular/core';
import { ILauncherRestClient } from "../../../rest-clients/application/launcher/i-launcher-rest.client";
import { launcherRestClientInjectionToken } from "../../../rest-clients/application/launcher/launcher-rest-client-injection-token";
import { ILauncherService } from "./i-launcher.service";
import { ICreateApplicationForm } from "../../../rest-clients/application/forms/i-create-application.form";
import { IGetApplicationPageForm } from "../../../rest-clients/application/forms/i-get-application-page.form";
import { ILauncher } from "../../../models/application/i-launcher";
import { ICreateRecordResponse, IPage } from '@zaeper/communication-lib';

@Injectable()
export class LauncherService implements ILauncherService {
  constructor(@Inject( launcherRestClientInjectionToken ) private readonly _launcherRestClient: ILauncherRestClient) {
  }

  public async createLauncherDraft(form: ICreateApplicationForm): Promise<string> {
    const response: ICreateRecordResponse = await this._launcherRestClient.createApplication( form );
    return Promise.resolve( response.recordId );
  }

  public async getLauncherPage(form: IGetApplicationPageForm): Promise<IPage<ILauncher>> {
    return this._launcherRestClient.getApplicationPage( form );
  }
}
